<template>
    <div class="qr-code">
        <div class="qr-code-outer">
        <div class="qr-code-container">
        <canvas ref="canvas"></canvas>
        </div>
        </div>
        <button class="more-inline more-inline2" @click="downloadQrCode">
            <span class="title">{{ trans("Download QR-code") }}</span>
            <Icon name="download" />
        </button>
    </div>
</template>

<script>
import { defineComponent, onMounted, watch, ref } from "vue";

import QRCode from "qrcode";

import Icon from "components/icon";

import trans from "helpers/_translation";

export default defineComponent({
    name: "qr",
    props: {
        url: {
            type: String,
            required: true
        }
    },
    components: {
        Icon
    },
    setup(props) {
        const canvas = ref(null);

        // Function to generate the QR code
        const generateQrCode = async (url) => {
            if (!canvas.value) return;
            try {
                await QRCode.toCanvas(canvas.value, url, {
                    width: 1500, // Adjust width as needed
                    margin: 2, // Adjust margin as needed
                });
            } catch (error) {
                console.error("Failed to generate QR code:", error);
            }
        };

        // Function to download the QR code
        const downloadQrCode = () => {
            if (!canvas.value) return;
            const link = document.createElement("a");
            link.href = canvas.value.toDataURL("image/png");
            link.download = "qr-code.png";
            link.click();
        };

        // Watch for changes in the `url` prop
        watch(
            () => props.url,
            (newUrl) => {
                generateQrCode(newUrl);
            }
        );

        // Generate the QR code on mount
        onMounted(() => {
            generateQrCode(props.url);
        });

        return {
            canvas,
            generateQrCode,
            downloadQrCode,
            trans
        };
    }
});
</script>